export function find(obj, predicate) {
    if (obj == null) {
        throw new TypeError('obj is null or not defined');
    }

    const o = Object(obj);

    const len = o.length >>> 0;

    if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
    }

    let k = 0;

    while (k < len) {
        const kValue = o[k];
        if (predicate.call(predicate, kValue, k, o)) {
            return kValue;
        }
        k++;
    }

    return undefined;
}

export function first(array) {
    return (array != null && array.length)
        ? array[0]
        : undefined;
}

// Based on https://github.com/Teun/thenBy.js
export function firstBy(func, opt?) {
    function identity(v) { return v; }

    function ignoreCase(v) { return typeof (v) === 'string' ? v.toLowerCase() : v; }

    function makeCompareFunction(f, compareOpt) {
        compareOpt = typeof (compareOpt) === 'number' ? { direction: compareOpt } : compareOpt || {};
        if (typeof (f) != 'function') {
            const prop = f;
            // make unary function
            f = function (v1) { return v1[prop] ? v1[prop] : ''; };
        }
        if (f.length === 1) {
            // f is a unary function mapping a single item to its sort score
            const uf = f;
            const preprocess = compareOpt.ignoreCase ? ignoreCase : identity;
            f = function (v1, v2) { return preprocess(uf(v1)) < preprocess(uf(v2)) ? -1 : preprocess(uf(v1)) > preprocess(uf(v2)) ? 1 : 0; };
        }
        if (compareOpt.direction === -1) return function (v1, v2) { return -f(v1, v2); };
        return f;
    }

    function tb(sourceFunc, sourceOpt) {
        const x = typeof (this) == 'function' ? this : false;
        const y = makeCompareFunction(sourceFunc, sourceOpt);
        const f = x ? function (a, b) {
            return x(a, b) || y(a, b);
        }
            : y;
        f.thenBy = tb;
        return f;
    }

    return tb(func, opt);
}

export function includes(array, item): boolean {
    return (array != null && array.length && item != null)
        ? array.indexOf(item) > -1
        : false;
}

export function last(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}

// Only non Symbol results of iteratee supported
export function max(array, iteratee) {
    let result;
    if (array == null) {
        return result;
    }
    for (const value of array) {
        let computed;
        const current = iteratee(value);

        if (current != null && (computed === undefined
            ? (current === current)
            : (current > computed)
        )) {
            computed = current;
            result = value;
        }
    }
    return result;
}

// Only non Symbol results of iteratee supported
export function min(array, iteratee) {
    let result;
    if (array == null) {
        return result;
    }
    for (const value of array) {
        let computed;
        const current = iteratee(value);

        if (current != null && (computed === undefined
            ? (current === current)
            : (current < computed)
        )) {
            computed = current;
            result = value;
        }
    }
    return result;
}

export function uniqueArray(array: string[] | number[] = []) {
    const returnArray = [...array];
    return returnArray.filter((val, ind, arr) => arr.indexOf(val) === ind);
}

export const cancelProductWithPackage = {
    'MegoPackageOptimum': ['Go2SeeServiceFreeSupport'],
    'MegoPackagePremium': ['Go2SeeRefund', 'Go2SeeNotification', 'Go2SeeServiceFreeSupport', 'MegoSmsTicket', 'MegoPackageSuperSms', 'MegoPackageAllInclusive'],
    'MegoPackageAllInclusive': ['Go2SeeServiceFlightFlexBooking', 'Go2SeeRefund', 'Go2SeeNotification', 'MegoPackagePremium']
};